import styles from "./style.module.scss"
import moreInfoIcon from "../../assets/icons/icon_info.png"
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import img1 from "../../assets/moreInfo/1.png"
import img2 from "../../assets/moreInfo/2.png"
import img3 from "../../assets/moreInfo/3.png"
import img4 from "../../assets/moreInfo/4.png"
import img5 from "../../assets/moreInfo/5.png"
import img6 from "../../assets/moreInfo/6.png"
import img7 from "../../assets/moreInfo/7.png"
import img8 from "../../assets/moreInfo/8.png"
import img9 from "../../assets/moreInfo/9.png"
import img10 from "../../assets/moreInfo/10.png"
import img11 from "../../assets/moreInfo/11.png"
import img12 from "../../assets/moreInfo/12.png"
import img13 from "../../assets/moreInfo/13.png"
import img14 from "../../assets/moreInfo/14.png"
import img15 from "../../assets/moreInfo/15.png"
export default function MoreInfo() {
    const images = [
        img1,
        img2,
        img4,
        img5,
        img6,
        img7,
        img8,
        img9,
        img10,
        img11,
        img13,
        img14,
        img15,
        img3,
        img12,]
    const figcaptions = [
        "Panorama Zagórowa 1939 r. Widać wieże kościołów oraz synagogę. Zdjęcie wykonane z wiatraka",
        "Gęsi – symbol Zagórowa",
        "Apteka. Znajdowała się tuż przy obecnym budynku apteki",
        "Członkowie społeczności żydowskiej",
        "Na łódce. Wytchnienie od codziennych spraw",
        "Dom Ludowy w Zagórowie",
        "Jarmark w Zagórowie. Końskie targowisko. Rok 1925",
        "Listonosz na dwukółce",
        "Duży Rynek i pomnik św. Wawrzyńca, który został zburzony na początku II wojny światowej",
        "Rybacy zagórowscy",
        "Wiatrak Gmachowskiego",
        "Targ na Dużym Rynku",
        "Zimą woły ciągnęły sanie i wozy",
        "Dożynki – czas świętowania, śpiewu i tańca",
        "Wózek z lodami firmy Chłodnickich. Na właściciela mówiono „Pikuś”, ponieważ miał psa o takim imieniu",
    ]
    const [showMoreInfo, setShowMoreInfo] = useState(false);
    return (
        <div className={styles.moreInfo}>
            {
                !showMoreInfo &&

                <button className={styles.button} onClick={() => setShowMoreInfo(!showMoreInfo)}>
                    <img src={moreInfoIcon} alt="" />
                </button>
            }
            {
                showMoreInfo &&
                <div className={styles.moreInfoPopup}>
                    <div className={styles.closeButton}>
                        <button onClick={() => setShowMoreInfo(!showMoreInfo)}><CloseIcon /></button>
                    </div>
                    <div className={styles.content}>
                        {images.map((image, index) => (
                            <div>
                                <img key={index} src={image} alt="" />
                                <figcaption>{figcaptions[index]}</figcaption>
                            </div>
                        ))}
                    </div>
                    <div className={styles.links}>
                        <h2>
                            Linki
                        </h2>
                        <div className={styles.list}>
                            <a href="https://www.youtube.com/watch?v=zCORX5LSb8w" target="_blank" rel="noopener noreferrer">
                                Skrzydła do nieba. Zagórowskie wiatraki
                            </a>
                            <a href="https://www.youtube.com/watch?v=3GXkGWWjx7A" target="_blank" rel="noopener noreferrer">
                                Wywiad z lektorami słuchowiska
                            </a>
                            <a href="https://www.youtube.com/watch?v=sPTFAgV2jPM" target="_blank" rel="noopener noreferrer">
                                Ludzie z żelaznych domów
                            </a>
                            <a href="https://www.youtube.com/watch?v=UgFiZVaqHRs" target="_blank" rel="noopener noreferrer">
                                „Droga do Zagórowa”, Daniel Słowiński
                            </a>
                            <a href="https://www.youtube.com/watch?v=XZi2fi77qlk" target="_blank" rel="noopener noreferrer">
                                Knajpa Łukaszewskiego. Wywiad z wnukiem Franciszka Łukaszewskiego Jezrym Napierałą
                            </a>
                            <a href="https://www.youtube.com/watch?v=hb3acPo_zT4" target="_blank" rel="noopener noreferrer">
                                O szewcach z Zagórowa. Wywiad z Krystyną Szelewicz-Cichocką
                            </a>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}